module.exports = __webpack_public_path__ + "static/img/window.f6e479c3.png";